function supportsWebP() {
	try {
		if (typeof document === "undefined") return true;
		return document.createElement("canvas").toDataURL("image/webp").indexOf("data:image/webp") === 0;
	} catch (err) {
		return false;
	}
}

module.exports = function ({ src, width, quality }) {
	if (src.startsWith("data:")) return src;
	if (!width) return src;
	if (src.includes("x-oss-process")) return src;

	const format = supportsWebP() ? "webp" : src.includes(".png") ? "png" : "jpg";

	const params = [`x-oss-process=image/resize,w_${width}`, quality && `quality,q_${quality || 1}`, "format," + format]
		.filter((x) => !!x)
		.join("/");

	return `${src}?${params}`;
};
